import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import icon_details from '../../../assets/images/details1.png'
import './Accounts.css'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import DivInfo from './DivInfo';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';
import { emptyOneAccount, loadOneAccount } from '../../../store/Actions/ActionAccounts';
import moment from 'moment';
import InnerLoader from '../../../components/general/inner-loader/InnerLoader';
import { formatNumberWithCommas } from '../../../components/general/general-component/abstruct-component/FunctionRemoveCommas';

function PopUpDetails({ account_id, open, setOpen }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { one_account, loadingOneAccount,currency  } = useSelectorCustom()
    useEffect(() => {
        dispatch(loadOneAccount(account_id))
    }, [])

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
                dispatch(emptyOneAccount())
            }}
            center
            classNames={{
                modal: `pop_center_details`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className='div_pop_material' dir={langLocal == "ar" ? "rtl" : "ltr"}  >
                <div className='top-details' >
                    <img src={icon_details} />
                </div>
                {
                    loadingOneAccount ? <div className='div-pop-loader' ><InnerLoader /></div> :
                        <>
                            <div className='user-info' >
                                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""} style={{ marginBottom: "5px" }} >{translate('user_info')}</h3>
                                <div >
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('name')} data={one_account?.user?.name}  />
                                        <DivInfo langLocal={langLocal} title={translate('email')} data={one_account?.user?.email}  />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('created_at')} data={moment(one_account?.user?.created_at).format("YYYY-MM-DD")}  />
                                        <DivInfo langLocal={langLocal} title={translate('status')} data={one_account?.user?.status ? "active" : "un active"}  />
                                    </div>

                                </div>
                            </div>
                            <div className='user-info' >
                                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""} style={{ marginBottom: "5px" }}>{translate('account_info')}</h3>
                                <div >
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('account_name')} data={one_account?.name}  />
                                        <DivInfo langLocal={langLocal} title={translate('type')} data={one_account?.type}  />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('amount')} data={` ${formatNumberWithCommas(one_account?.amount)}   ${translate(currency)}`}  />
                                        <DivInfo langLocal={langLocal} title={translate('created_at')}  data={moment(one_account?.created_at).format("YYYY-MM-DD")}  />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} >
                                        <DivInfo langLocal={langLocal} title={translate('created_by')} data={one_account?.created_by?.name}  />
                                        <DivInfo langLocal={langLocal} title={translate('status')} data={one_account?.status ? "active" : "un active"}  />
                                    </div>
                                </div>
                            </div>
                        </>
                }

            </div>
        </RModal>
    )
}

export default PopUpDetails